exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thead-light th {\n    border-top: none;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mjahoo/workspace/rento/git/saunasampo-monitor/src/app/device/devices/devices.component.css
// module id = ../../../../../src/app/device/devices/devices.component.css
// module chunks = main